import { USER_ROLES } from '../../auth/index';

const PERMISSIONS = [
	USER_ROLES.CSM,
	USER_ROLES.IMPLEMENTATION,
	USER_ROLES.LANGOS_APP,
	USER_ROLES.OPS,
	USER_ROLES.OWNER,
	USER_ROLES.LANGOPS,
	USER_ROLES.ADMIN,
];

export default {
	USERS: {
		ACTIVE: true,
		NAME: 'manage-users',
		LABEL: 'User Management',
		ICON: 'multiple-actions-address',
		PATH: '/users/:section',
		CHILDREN: [
			'USERS_ALL',
			'USERS_NEW',
			'USERS_NEW_REVIEWER',
			'USER_PROFILE_EDIT',
			'USER_REVIEWER_PROFILE',
		],
		PERMISSIONS,
		DISPLAY_CHILDREN: false,
	},

	USERS_ALL: {
		ACTIVE: true,
		NAME: 'manage-users-all',
		LABEL: 'Users',
		PARAMS: {
			section: 'all',
		},
		PERMISSIONS,
	},
	USERS_NEW: {
		ACTIVE: true,
		NAME: 'users-new',
		LABEL: 'New User',
		PARAMS: {
			section: 'new',
		},
		PERMISSIONS,
	},
	USERS_NEW_REVIEWER: {
		ACTIVE: true,
		NAME: 'users-new-reviewer',
		LABEL: 'New Reviewer',
		PARAMS: {
			section: 'new-reviewer',
		},
		PERMISSIONS,
	},
	USER_PROFILE_EDIT: {
		ACTIVE: true,
		NAME: 'edit-user-profile',
		LABEL: 'Edit User',
		PARAMS: {
			section: 'profile',
		},
		PERMISSIONS,
	},
	USER_REVIEWER_PROFILE: {
		ACTIVE: true,
		NAME: 'edit-reviewer-profile',
		LABEL: 'Edit Reviewer',
		PARAMS: {
			section: 'cr-profile',
		},
		PERMISSIONS,
	},
};
